/**
 * @param {object} [context]
 * @param {boolean} [context.hasQuestions]
 */
export function buildQmsQuizBuilderTourSteps(context = {}) {
  const { hasQuestions = false } = context;

  const steps = [
    {
      id: "welcome",
      placement: "center",
      title: "Create or edit a quiz",
      body: "This full-screen workspace has quiz settings on the left and question assignment on the right. Use Guide anytime to replay these tips.",
    },
    {
      id: "quiz-settings",
      target: '[data-tour="qms-quiz-builder-form"]',
      placement: "right",
      title: "Quiz settings",
      body: "Enter the quiz name, passing score, attempt limit (0 = unlimited), and how many random questions to serve per attempt. Leave serve count blank to use all assigned questions.",
    },
    {
      id: "assigned-summary",
      target: '[data-tour="qms-quiz-builder-summary"]',
      placement: "right",
      title: "Assignment count",
      body: "This summary shows how many questions are assigned out of the total in question master. At least one question must be assigned before you can save.",
    },
    {
      id: "quick-help",
      target: '[data-tour="qms-quiz-builder-quick-help"]',
      placement: "bottom",
      title: "Quick tips",
      body: "Expand Quick tips anytime for a short checklist. It stays in the assignment area while you work.",
      when: () => hasQuestions,
    },
    {
      id: "assigned-list",
      target: '[data-tour="qms-quiz-builder-assigned"]',
      placement: "left",
      title: "Assigned questions",
      body: "Questions already in this quiz appear here. Search filters this list only. Click − on a row to remove one question, or Remove all to clear the quiz.",
      when: () => hasQuestions,
    },
    {
      id: "view-options",
      target: '[data-tour="qms-quiz-builder-options-toggle"]',
      placement: "left",
      title: "Preview options",
      body: "Click View options on any question to expand its four answers. The correct option is marked in green. Options stay hidden until you choose to view them.",
      when: () => hasQuestions,
    },
    {
      id: "unassigned-list",
      target: '[data-tour="qms-quiz-builder-unassigned"]',
      placement: "left",
      title: "Unassigned questions",
      body: "Pick questions from question master here. Click + on a row to assign one, or Add all to assign every unassigned question. Search works independently from the assigned list.",
      when: () => hasQuestions,
    },
    {
      id: "footer",
      target: '[data-tour="qms-quiz-builder-footer"]',
      placement: "top",
      title: "Save your quiz",
      body: "Click Save when settings and assignments look correct. Cancel closes without saving.",
    },
    {
      id: "guide-button",
      target: '[data-tour="qms-quiz-builder-guide"]',
      placement: "bottom",
      title: "Reopen this guide",
      body: "Use Guide in the header whenever you need a refresher on assigning questions or quiz settings.",
    },
    {
      id: "done",
      placement: "center",
      title: "You are ready",
      body: "Assign questions, preview options when needed, then save. Scroll lists with the light scrollbar on the right edge of each panel.",
    },
  ];

  return steps.filter((step) => (step.when ? step.when(context) : true));
}
